/* eslint-disable max-lines-per-function */
import type { ActiveModel } from '@3d4medical/websdk';
import { useBridge } from '@completeanatomy/bridge';
/* eslint-disable */
import { useState, useCallback, useEffect } from 'react';
import { useAnalytics } from '@completeanatomy/analytics';
import useApp from './useApp';

const useModel = () => {
  const [activeModel, setActiveModel] = useState<ActiveModel | null>(null);
  const bridge = useBridge();
  const { app, screen, isSetup } = useApp();
  const analytics = useAnalytics();

  const activateScreen = useCallback(async () => {
    if (!app) {
      return;
    }

    const screenId = screen?.id || +(process.env.SCREEN_ID || '0');

    const activatedModel = screen
      ? await app.activateModelWithExternalScreen(
          screen.id,
          screen as any,
          true,
          true,
          true,
          true
        )
      : await app.activateModelWithScreen(screenId, undefined, undefined, true);

    analytics.log('screen_opened' as any, {
      screen_id: screenId,
      screen_name: screen?.name,
      resource_type: 'screen',
    });

    setActiveModel(app.getActiveModel());
  }, [app, screen]);

  useEffect(() => {
    if (!isSetup) {
      return;
    }

    activateScreen();
  }, [isSetup]);

  return { app, activeModel };
};

export default useModel;
